import { useSelector } from 'react-redux';
import { isIosMobileBrowser } from '../base/environment/utils';
import PiPButton from './components/web/PiPButton';
import { shouldShowPiP } from './functions';
// Web 解析优先 hooks.web.ts。canvas avatar 实现放在独立文件，避免与本文件同名 hooks.ts 被遮蔽。
export { useCanvasAvatar } from './useCanvasAvatar';
const PIP_TOOLBOX_BUTTON = {
    key: 'pip',
    Content: PiPButton,
    group: 4
};
/**
 * 返回画中画工具栏按钮配置；不可用时返回 undefined。
 *
 * @returns {Object | undefined}
 */
export function usePipButton() {
    const visible = useSelector((state) => shouldShowPiP(state) && !isIosMobileBrowser());
    if (visible) {
        return PIP_TOOLBOX_BUTTON;
    }
}
